export default __webpack_public_path__ + "static/media/JOSA.8b017174.pdf";